module.exports = __webpack_public_path__ + "static/media/tab_5.098be512.png";